import NewsGet from "./Get";
import NewsCreate from "./Create";
import NewsUpdate from "./Update";
import ShowNews from "./ShowNews";
// import StoreCoupon from './Coupon'
// import StoreCoupons from './GetCoupon'
// import StoreDetails from './Details'

export {
  NewsGet,
  NewsCreate,
  NewsUpdate,
  ShowNews,
  // StoreCoupon,
  // StoreCoupons
  // StoreDetails,
};
